/* ==========================================================================
   شهد بيوتي - بكج النيلة - الجافاسكربت المشترك
   ========================================================================== */

(function() {
  'use strict';

  const arabicNums = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  window.shahdToArabic = function(n) {
    return String(n).split('').map(c => arabicNums[parseInt(c)] || c).join('');
  };

  // ===== شريط قبل/بعد =====
  document.querySelectorAll('[data-shahd-ba]').forEach(slider => {
    const handle = slider.querySelector('[data-ba-handle]');
    const after = slider.querySelector('[data-ba-after]');
    const dayNum = slider.querySelector('[data-ba-day]');
    if (!handle || !after) return;
    let dragging = false;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      handle.style.left = pct + '%';
      after.style.clipPath = `polygon(0 0, ${pct}% 0, ${pct}% 100%, 0 100%)`;
      if (dayNum) {
        const day = Math.round((pct / 100) * 14);
        dayNum.textContent = window.shahdToArabic(day);
      }
    }

    function move(x) {
      const r = slider.getBoundingClientRect();
      setPos(((x - r.left) / r.width) * 100);
    }

    slider.addEventListener('mousedown', e => { dragging = true; move(e.clientX); });
    slider.addEventListener('touchstart', e => { dragging = true; if(e.touches[0]) move(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mousemove', e => dragging && move(e.clientX));
    document.addEventListener('touchmove', e => dragging && e.touches[0] && move(e.touches[0].clientX), { passive: true });
    document.addEventListener('mouseup', () => dragging = false);
    document.addEventListener('touchend', () => dragging = false);
  });

  // ===== أكورديون الأسئلة =====
  document.querySelectorAll('[data-shahd-faq-q]').forEach(q => {
    q.addEventListener('click', function() {
      const item = this.closest('[data-shahd-faq-item]');
      const list = item.parentNode;
      list.querySelectorAll('[data-shahd-faq-item].is-open').forEach(el => {
        if (el !== item) el.classList.remove('is-open');
      });
      item.classList.toggle('is-open');
    });
  });

  // ===== العداد التنازلي =====
  document.querySelectorAll('[data-shahd-countdown]').forEach(cd => {
    const endDate = cd.dataset.shahdCountdown;
    const hEl = cd.querySelector('[data-cd-h]');
    const mEl = cd.querySelector('[data-cd-m]');
    const sEl = cd.querySelector('[data-cd-s]');
    const dEl = cd.querySelector('[data-cd-d]');
    const useArabic = cd.dataset.cdArabic === 'true';

    let target;
    if (endDate && endDate !== 'auto') {
      target = new Date(endDate).getTime();
    } else {
      target = Date.now() + (23 * 3600 + 45 * 60 + 12) * 1000;
    }

    function update() {
      const diff = target - Date.now();
      if (diff <= 0) {
        if (hEl) hEl.textContent = useArabic ? '٠٠' : '00';
        if (mEl) mEl.textContent = useArabic ? '٠٠' : '00';
        if (sEl) sEl.textContent = useArabic ? '٠٠' : '00';
        if (dEl) dEl.textContent = useArabic ? '٠' : '0';
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const fmt = n => {
        const s = String(n).padStart(2, '0');
        return useArabic ? window.shahdToArabic(s) : s;
      };

      if (dEl) dEl.textContent = useArabic ? window.shahdToArabic(days) : days;
      if (hEl) hEl.textContent = fmt(hours);
      if (mEl) mEl.textContent = fmt(minutes);
      if (sEl) sEl.textContent = fmt(seconds);
    }

    update();
    setInterval(update, 1000);
  });

  // ===== المعرض =====
  document.querySelectorAll('[data-shahd-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        const src = t.dataset.galleryThumb;
        if (main) main.src = src;
        thumbs.forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  // ===== المشاهدين الزائف =====
  document.querySelectorAll('[data-shahd-live]').forEach(el => {
    const min = parseInt(el.dataset.shahdLiveMin || 15);
    const max = parseInt(el.dataset.shahdLiveMax || 45);
    setInterval(() => {
      const change = Math.random() > 0.5 ? 1 : -1;
      let current = parseInt(el.textContent);
      current = Math.max(min, Math.min(max, current + change));
      el.textContent = current;
    }, 4000);
  });

  // ===== الشريط الثابت =====
  const stickyBar = document.querySelector('[data-shahd-sticky-bar]');
  const heroSection = document.querySelector('[data-shahd-hero]');
  if (stickyBar && heroSection) {
    window.addEventListener('scroll', () => {
      const heroRect = heroSection.getBoundingClientRect();
      stickyBar.classList.toggle('is-visible', heroRect.bottom < 100);
    });
  }

  // ===== التابات (للتفاصيل وطريقة الاستخدام) =====
  document.querySelectorAll('[data-shahd-tabs]').forEach(tabsContainer => {
    const tabs = tabsContainer.querySelectorAll('[data-tab-trigger]');
    const panels = tabsContainer.querySelectorAll('[data-tab-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTrigger;
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        panels.forEach(p => {
          p.classList.toggle('is-active', p.dataset.tabPanel === target);
        });

        // علامة "تم" للتابات السابقة (لطريقة الاستخدام)
        if (tabsContainer.dataset.shahdTabs === 'sequential') {
          const targetIdx = parseInt(target);
          tabs.forEach((t, i) => {
            t.classList.remove('is-done');
            if (i < targetIdx) t.classList.add('is-done');
          });
        }
      });
    });
  });

  // ===== أزرار "السابق/التالي" =====
  document.querySelectorAll('[data-shahd-tab-nav]').forEach(btn => {
    btn.addEventListener('click', () => {
      const direction = btn.dataset.shahdTabNav;
      const container = btn.closest('[data-shahd-tabs]');
      if (!container) return;
      const tabs = container.querySelectorAll('[data-tab-trigger]');
      const activeIdx = Array.from(tabs).findIndex(t => t.classList.contains('is-active'));
      let newIdx = direction === 'next' ? activeIdx + 1 : activeIdx - 1;
      newIdx = Math.max(0, Math.min(tabs.length - 1, newIdx));
      tabs[newIdx].click();
    });
  });

  // ===== كمية المنتج =====
  document.querySelectorAll('[data-shahd-qty]').forEach(qtyEl => {
    const input = qtyEl.querySelector('input');
    qtyEl.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.qtyAction;
        let val = parseInt(input.value) || 1;
        if (action === 'plus') val++;
        else if (action === 'minus' && val > 1) val--;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

})();
